// @ts-nocheck
import { IAssignedUserModel } from '../models/AssignedUserModel';

export const getInitials = (user: IAssignedUserModel): string => {
  return user?.firstName?.charAt(0) + user?.lastName?.charAt(0);
};

export const getInitialsFromString = (user: string): string => {
  return user
    .trim()
    .split(' ')
    .reverse()
    .map((word) => word.charAt(0))
    .join('');
};

export const adjustFontSizeAvatar = (initialsLength: number) => {
  return Math.max(6, 12 + 2 * (2 - initialsLength));
};
